/**
 * size: Section's size     string
 *     options: "medium", "large"
 *
 */

import React from "react";

function Section({ size }) {
	const ReturnSize = () => {
		switch (size) {
			case "medium":
				return null;
			case "large":
				return <div className="col_1" />;
			default:
				return null;
		}
	};

	return <div className="has_cols_2">{ReturnSize()}</div>;
}

Section.defaultProps = {
	size: "medium",
};

export default Section;
